import { Platform } from "./db";
import { BackendColumns, PROSPECT_INFO_COLUMNS } from "./table";


export enum ProspectInfoTypes {
  CADENCE_STEPS = 'cadence_steps',
  CADENCES = 'cadence',
  TITLES = 'title',
  SENIORITIES = 'seniority',
  INDUSTRIES = 'industry'
}

export type ProspectInfoChoice = {
  field_name: BackendColumns
  choices: string[]
}

export type ProspectInfoChoices = ProspectInfoChoice[]

export type ProspectInfo = {
  platform: Platform
  [PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_ID]: string | null
  [PROSPECT_INFO_COLUMNS.PLATFORM_COMPANY_ID]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_VALUE]: string | null
  [PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_URL]: string | null
  [PROSPECT_INFO_COLUMNS.XREF_PLATFORM]: Platform 
  [PROSPECT_INFO_COLUMNS.XREF_PERSON_ID]: string | null
  [PROSPECT_INFO_COLUMNS.XREF_COMPANY_ID]: string | null
  [PROSPECT_INFO_COLUMNS.XREF_PERSON_URL]: string | null
  [PROSPECT_INFO_COLUMNS.CADENCE]: string | null
  [PROSPECT_INFO_COLUMNS.CADENCE_2]: string | null
  [PROSPECT_INFO_COLUMNS.CADENCE_3]: string | null
  [PROSPECT_INFO_COLUMNS.CADENCE_STEP]: string | null
  [PROSPECT_INFO_COLUMNS.CADENCE_STEP_2]: string | null
  [PROSPECT_INFO_COLUMNS.CADENCE_STEP_3]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_NAME]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_TITLE]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_OCCUPATION]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_SENIORITY]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_LINKEDIN]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_EMAIL]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_1]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_2]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_NAME]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_LINKEDIN]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_URL]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_2]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_3]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MIN]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MAX]: string | null
  [PROSPECT_INFO_COLUMNS.COMPANY_PERSONA]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_LIST]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_LIST_2]: string | null
  [PROSPECT_INFO_COLUMNS.PROSPECT_LIST_3]: string | null
  [PROSPECT_INFO_COLUMNS.MARKET]: string | null
  [PROSPECT_INFO_COLUMNS.LEAD_TYPE]: string | null
}

export function jsonSafeToProspectInfo(record: Record<string, any>): ProspectInfo {
  return {
    platform: record.platform,
    [PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_ID]: record.platform_person_id,
    [PROSPECT_INFO_COLUMNS.PLATFORM_COMPANY_ID]: record.platform_company_id,
    [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_VALUE]: record.prospect_phone_value,
    [PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_URL]: record.platform_person_url,
    [PROSPECT_INFO_COLUMNS.XREF_PLATFORM]: record.xref_platform,
    [PROSPECT_INFO_COLUMNS.XREF_PERSON_ID]: record.xref_person_id,
    [PROSPECT_INFO_COLUMNS.XREF_COMPANY_ID]: record.xref_company_id,
    [PROSPECT_INFO_COLUMNS.XREF_PERSON_URL]: record.xref_person_url,
    [PROSPECT_INFO_COLUMNS.CADENCE]: record.cadence,
    [PROSPECT_INFO_COLUMNS.CADENCE_2]: record.cadence_2,
    [PROSPECT_INFO_COLUMNS.CADENCE_3]: record.cadence_3,
    [PROSPECT_INFO_COLUMNS.CADENCE_STEP]: record.cadence_step,
    [PROSPECT_INFO_COLUMNS.CADENCE_STEP_2]: record.cadence_step_2,
    [PROSPECT_INFO_COLUMNS.CADENCE_STEP_3]: record.cadence_step_3,

    [PROSPECT_INFO_COLUMNS.PROSPECT_NAME]: record.prospect_name,
    [PROSPECT_INFO_COLUMNS.PROSPECT_TITLE]: record.prospect_title,
    [PROSPECT_INFO_COLUMNS.PROSPECT_OCCUPATION]: record.prospect_occupation,
    [PROSPECT_INFO_COLUMNS.PROSPECT_SENIORITY]: record.prospect_seniority,
    [PROSPECT_INFO_COLUMNS.PROSPECT_LINKEDIN]: record.prospect_linkedin,
    [PROSPECT_INFO_COLUMNS.PROSPECT_EMAIL]: record.prospect_email,
    [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_1]: record.prospect_phone_other_1,
    [PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_2]: record.prospect_phone_other_2,

    [PROSPECT_INFO_COLUMNS.COMPANY_NAME]: record.company_name,
    [PROSPECT_INFO_COLUMNS.COMPANY_LINKEDIN]: record.company_linkedin,
    [PROSPECT_INFO_COLUMNS.COMPANY_URL]: record.company_url,
    [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY]: record.company_industry,
    [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_2]: record.company_industry_2,
    [PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_3]: record.company_industry_3,
    [PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MIN]: record.company_size_min,
    [PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MAX]: record.company_size_max,
    [PROSPECT_INFO_COLUMNS.COMPANY_PERSONA]: record.company_persona,
    [PROSPECT_INFO_COLUMNS.PROSPECT_LIST]: record.prospect_list,
    [PROSPECT_INFO_COLUMNS.PROSPECT_LIST_2]: record.prospect_list_2,
    [PROSPECT_INFO_COLUMNS.PROSPECT_LIST_3]: record.prospect_list_3,
    [PROSPECT_INFO_COLUMNS.MARKET]: record.market,    
    [PROSPECT_INFO_COLUMNS.LEAD_TYPE]: record.lead_type,
  }
}
